<template>
  <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">BID {{ bidwanted.cusip }}</h5>
          <div class="float-right">
            <span class="mr-3" v-if="maxQuantitySet && (totalQuantity > maxQuantity)">
              <span class="alert alert-danger" role="alert">Quantity Exceeded</span>                
            </span>
            <button class="btn btn-light" @click="$emit('close')" type="button">
              Cancel
            </button>
            <button
               v-if="maxQuantitySet"
              :disabled="!price || (totalQuantity > maxQuantity)"
              class="btn btn-primary"
              type="button"
              @click="sendQuote()"
            >
              BID
            </button>
            <button
               v-if="!maxQuantitySet"
              :disabled="!price"
              class="btn btn-primary"
              type="button"
              @click="sendQuote()"
            >
              BID
            </button>
            <button type="button" class="close" @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <!-- <div>
            <h4>CUSIP : {{ bidwanted.cusip }}</h4>
          </div> -->
          <div class="row">
            <div class="col-md-3">
              <label for="accountno required">Price *</label>
              <div class="input-group mb-3">
                <input
                  v-debounce:300ms="() => priceChanged(bidwanted)"
                  type="number"
                  maxlength="15"
                  class="form-control"
                  id="accountno"
                  placeholder="Price"
                  v-model="price"
                />
                <span v-if="isIDCPriceLimitExceed">
                  <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>BID Price is out of line - IDC Tolerance.</span>
                <span v-if="isOfferPriceLimitExceed">
                  <i  class="fa fa-exclamation-triangle text-dark-red mr-1" aria-hidden="true"></i>BID Price is out of line - IMS/ARBS Offer Price.</span>
              </div>
            </div>
            <div class="col-md-3">
              <label for="accountno required">Quantity</label>
              <div style="padding: 8px;color: #0084cc;">
                <span>{{totalQuantity}}</span>
              </div>
            </div>
            <div class="col-md-3" v-if="maxQuantitySet">
              <label for="accountno required">Max Quantity</label>
              <div style="padding: 8px;color: #ff4500;">
                <span>{{maxQuantity}}</span>
              </div>
            </div>
          </div>
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="ACTIVE BID WANTEDS" active>
                <div class="row xsOnly">
                  <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                      <div class="table-responsive">
                        <div v-if="loading" class="loader">
                          <img src="@/assets/img/loader.svg" alt="" />
                        </div>
                        <table
                          class="table align-items-center table-flush table-hover bidtbl"
                          style="min-height: 125px"
                        >
                          <thead class="thead-light psticky">
                            <tr>
                              <!-- <th 
                                    scope="col" 
                                    class="sort text-center"
                                     >Cusip</th> -->
                              <th scope="col" class="sort text-center">QTY</th>
                              <th scope="col" class="sort text-center">ECN</th>
                              <th scope="col" class="sort text-center">
                                SETTLEMENT DATE
                              </th>
                              <!-- <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >TRADER</th>   -->
                              <th scope="col" class="sort text-left">
                                Collection Details
                              </th>
                              <th scope="col" class="sort text-center">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody class="list no-cursor">
                            <tr v-if="bidwantedList.length == 0 && !loading">
                              <td><p class="nodata">No data available</p></td>
                            </tr>
                            <tr
                              v-for="(data, indexBid) in bidwantedList"
                              :key="indexBid"
                            >
                              <!-- <td class="text-center"><span class="cusips">{{data.cusip}}</span></td> -->
                              <td class="text-center">{{ data.orderQty }}</td>
                              <td class="text-center">
                                {{ data.ecn }}
                              </td>
                              <td class="text-center">
                                {{
                                  data.settleDate
                                    ? moment(data.settleDate).format(
                                        "MM/DD/YYYY"
                                      )
                                    : "N/A"
                                }}
                              </td>
                              <!-- <td class="text-center">{{data.traderFirstName}} {{data.traderLastName}}</td> -->
                              <td class="text-left">
                                <span v-if="data.ecn == 'IBP'"
                                  ><span class="maturity"
                                    >Collecting Until</span
                                  >
                                  :
                                  <span class=""
                                    >{{
                                      data.bidBy
                                        ? moment
                                            .utc(data.bidBy)
                                            .tz("America/New_York")
                                            .format("hh:mm:ss a")
                                        : "N/A"
                                    }}
                                    EST</span
                                  ></span
                                >
                                <span v-if="data.ecn == 'TMC'">
                                  <div>
                                    <span class="maturity"
                                      >Collecting Until</span
                                    >
                                    :
                                    <span class=""
                                      >{{
                                        data.bidBy
                                          ? moment
                                              .utc(data.bidBy)
                                              .tz("America/New_York")
                                              .format("hh:mm:ss a")
                                          : "N/A"
                                      }}
                                      EST</span
                                    >
                                  </div>
                                  <div>
                                    <span class="maturity">Firm Until</span> :
                                    <span class=""
                                      >{{
                                        data.firmUntill
                                          ? moment
                                              .utc(data.firmUntill)
                                              .tz("America/New_York")
                                              .format("hh:mm:ss a")
                                          : "N/A"
                                      }}
                                      EST</span
                                    >
                                  </div>
                                </span>
                                <span v-if="data.ecn == 'TWD'">
                                  <div>
                                    <span class="maturity"
                                      >Collection Type</span
                                    >
                                    :
                                    <span class="">{{
                                      data.collectionTypeDisplay
                                    }}</span>
                                  </div>
                                  <div>
                                    <span class="maturity"
                                      >Collecting Until</span
                                    >
                                    :
                                    <span class=""
                                      >{{
                                        data.bidBy
                                          ? moment
                                              .utc(data.bidBy)
                                              .tz("America/New_York")
                                              .format("hh:mm:ss a")
                                          : "N/A"
                                      }}
                                      EST</span
                                    >
                                  </div>
                                  <div v-if="data.collectionType == 'OPEN'">
                                    <span class="maturity">Firm Until</span> :
                                    <span class=""
                                      >Bid time +{{
                                        data.goodForTime
                                          ? data.goodForTime / 60 + "Mins"
                                          : "N/A"
                                      }}
                                      EST</span
                                    >
                                  </div>
                                  <div v-if="data.collectionType != 'OPEN'">
                                    <span class="maturity">Firm Until</span> :
                                    <span class=""
                                      >{{
                                        moment
                                          .utc(data.postAtTime)
                                          .add(data.goodForTime, "seconds")
                                          .tz("America/New_York")
                                          .format("hh:mm:ss a")
                                      }}
                                      EST</span
                                    >
                                  </div>
                                  <div
                                    v-if="
                                      data.collectionType != 'DEFINEDWOREVIEW'
                                    "
                                  >
                                    <span class="maturity">Review Period</span>
                                    :
                                    <span class=""
                                      >{{
                                        moment(data.postAtTime).diff(
                                          data.bidBy,
                                          "minutes"
                                        )
                                      }}
                                      Mins
                                    </span>
                                  </div>
                                </span>
                              </td>
                              <td class="text-center">
                                <button
                                  @click="deleteInventory(indexBid)"
                                  title="Delete"
                                  class="btn btn-outline-danger btn-sm"
                                >
                                  <i class="far fa-trash-alt"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                          class="mt-4"
                          :total-rows="totalRows"
                          v-model="currentPage"
                          :per-page="perPage"
                          @input="getBidwantedList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                          <span>Total Records : {{ totalRows }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="TODAY'S BIDS">
                <TodayBids v-bind:cusip="bidwanted.cusip"/>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import TodayBids from "../common/TodaysBid";
export default {
  name: "sendBidModal",
  components: {
    TodayBids
  },
  props: ["bidwanted"],
  data() {
    return {
      loading: false,
      price: null,
      currentPage: 1,
      perPage: 25,
      searchValue: this.bidwanted.cusip,
      totalRows: 0,
      sortColumn: "id",
      sortOrder: "DESC",
      bidwantedList: [],
      status: "NEW,BID_CANCELLED",
      defaultRange: 0,
      isIDCPriceLimitExceed : false,
      isOfferPriceLimitExceed : false,
      idcTollerance : 0,
      maxQuantity : 0,
      totalQuantity : 0,
      maxQuantitySet : false,
      toDaysBidsCount : 0
    };
  },
  methods: {
    priceChanged(cusipData){
      if(cusipData.idcPrice){
        if(this.idcTollerance){
          this.isIDCPriceLimitExceed = (this.price - cusipData.idcPrice) > (3 * this.idcTollerance);
        }
        this.checkOfferPriceValidation(cusipData);
      }else{
        this.getIdcPrice(cusipData);
        this.checkOfferPriceValidation(cusipData);
      }
    },
    checkOfferPriceValidation(cusipData){
      if(cusipData.ecnSentOfferPrice){
        this.isOfferPriceLimitExceed = cusipData.ecnSentOfferPrice < this.price;
      }
      else{
        this.getOfferPrice(cusipData,() =>{
          cusipData.isValidationCheckDone = true
        });
      }
    },
    getOfferPrice(cusipData,cb) {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/offer/check-offer-feed-exist?cusip="+cusipData.cusip,
          auth
        )
        .then((result) => {
          let offerInEcn = result.data[0];
          if(offerInEcn){
            this.isOfferPriceLimitExceed = offerInEcn.price < this.price;
            cusipData.ecnSentOfferPrice = offerInEcn.price;
          }
          cb(cusipData)
        })
        .catch((e) => {
          console.log("Error", e);
        });
    },
    getIdcPrice(cusipData){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = { "cusip": cusipData.cusip, 
                    "fetchAskEval": false,
                    "fetchAmendmentDate":false,
                    "fetchYield":false,
                    "fetchInstMidEval":false,
                    "fetchMidEval":false,
                    "fetchInstBidEval":false,
                    "fetchBidEval":true,
                    "fetchInstAskEval":false,
                    "fetchViaApi" : false,
                    "userId":  authService.getUser().id
                   }
      if(window.location.pathname.includes("/autobidder/supportdata")){
        data.fetchViaApi = true
      }

      this.$http
        .post(
          config.baseUrlAutoBidder +"/rplus/idc-data",data,
          auth
        )
        .then((result) => {
          if (result.data) {
            cusipData.idcPrice = result.data.bid.evaluation;
            if(this.idcTollerance)
            this.isIDCPriceLimitExceed = (this.price - cusipData.idcPrice)  > ( 3 * this.idcTollerance)
          }
          
        })
    },
    getBidwantedList() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let currentDate = this.moment.utc().format("YYYY-MM-DD hh:mm:ss a");
      let today = this.moment().format("MM-DD-YYYY");
      let fromDate = this.moment(today).utc().format("YYYY-MM-DD HH:mm:ss");
      // let minRange = "";
      // let maxRange = "";
      // if (this.defaultRange != 0) {
      //   minRange = this.bidwanted.orderQty - this.defaultRange;
      //   maxRange = this.bidwanted.orderQty + this.defaultRange;
      // } else {
      //   minRange = "";
      //   maxRange = "";
      // }

      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=" +
            this.status +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&currentDate=" +
            currentDate +
            "&loggedUser="+
            authService.getUser().id+
            "&minQuantity=" +
            // minRange +
            // "&maxQuantity=" +
            // maxRange +
            "&fromDate=" +
            fromDate,
          auth
        )
        .then((result) => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach((element) => {
            if (element.collectionType == "OPEN") {
              element.collectionTypeDisplay = "Open";
            }
            if (element.collectionType == "DEFINEDWREVIEW") {
              element.collectionTypeDisplay = "Defined With Review  ";
            }
            if (element.collectionType == "DEFINEDWOREVIEW") {
              element.collectionTypeDisplay = "Defined Without Review";
            }
          });
          this.bidwantedList = result.data.content;
          this.totalQuantity = this.bidwantedList.reduce((sum, item) => sum + item.orderQty, 0);
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    deleteInventory(removeIndex) {
      var message = "Are you sure you want to delete this bidwanted? ";
      this.$confirm(message, "Delete", "question", {
        confirmButtonText: "Delete",
        cancelButtonText: "No",
      }).then(() => {
        this.bidwantedList.splice(removeIndex, 1);
        this.totalQuantity = this.bidwantedList.reduce((sum, item) => sum + item.orderQty, 0);

      });
    },
    sendQuote() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let bidWnatedId = [];
      // bidWnatedId.push({
      //       "autoBidBwId": this.bidwanted.id,
      //       "price": this.price,
      //       "cognitoSub": authService.getUser().cognitoSub
      //     })
      if (this.bidwantedList.length) {
        this.bidwantedList.map((bid) => {
          bidWnatedId.push({
            autoBidBwId: bid.id,
            price: this.price,
            cognitoSub: authService.getUser().cognitoSub,
          });
        });
      }
      //console.log(bidWnatedId)
      this.$http
        .post(
          config.baseUrlAutoBidder + "/autobidder/sendquote",
          bidWnatedId,
          auth
        )
        .then(() => {
          this.$alert("Bid successfully", "", "success");
          this.loading = false;
          this.$emit("close","BIDDED",bidWnatedId);
        })
        .catch(() => (this.loading = false));
    },
    getUserSetting() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/tradebook/setting-list?cognitoSub=" +
            authService.getUser().cognitoSub,
          auth
        )
        .then((result) => {
          this.userSettings = result.data;
          this.userSettings.forEach((element) => {
            if (element.setting == "AUTOBIDDER_BID_QUANTITY_RANGE") {
              this.defaultRange = Number(element.value);
            }
            if(element.setting == "BID_PRICE_CHECK_FACTOR"){
              this.idcTollerance = Number(element.value)
            }
            if(element.setting == "AUTOBIDDER_MAX_QTY"){
              if(element.value === null || element.value === ""){
                this.maxQuantitySet = false
              }else{
                this.maxQuantitySet = true
              }
              this.maxQuantity = Number(element.value) - this.toDaysBidsCount
            }
          });

          this.getBidwantedList();
          this.priceChanged(this.bidwanted)
          // this.loading = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getTodaysBidsCount() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/bidqty-count?id="+this.bidwanted.id+"&cognitoSub="+authService.getUser().cognitoSub,
          auth
        )
        .then((result) => {
         this.toDaysBidsCount = result.data;
         this.getUserSetting();
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.price = this.bidwanted.bidQuoteAmount;
    this.getTodaysBidsCount();
  },
};
</script>